
import ResearchInfrastructureRepositoryAPI from "@/modules/research-infrastructure/research-infrastructure-repository-api";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import axios from "@/services/axios";
import { lazyParamsDefault } from "@/utils/pagination-helper";
import { FilterMatchMode } from "primevue/api";
import { computed, defineComponent, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  setup() {
    const { t } = useI18n();
    const filters = reactive({
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const { setResearchInfrastructure, loadItems, loadItem } =
      ResearchInfrastructureRepositoryAPI();
    const {
      hasBriumAccessRole,
      hasUniversityAccessRole,
      hasFacultyAccessRole,
      getUser,
    } = UserRepositoryAPI();

    const state = reactive({
      users: [],
      selectedRow: [],
      editingRows: [],
      dataLoading: true,
      infrastructureGroup: [] as Array<any>,
      lazyParams: lazyParamsDefault,
      keywords: "",
    });

    const onRowSelect = (event: any): void => {
      setResearchInfrastructure(event.data);
    };

    const onPaginatorResearchEquipmentClick = (event: any): void => {
      state.lazyParams = event;
      loadItems(state);
    };

    async function loadUsers() {
      const response = await axios.get("api/v1/User?PageNumber=0&PageSize=500");
      state.users = response.data;
    }

    onMounted(() => {
      loadUsers();
      onPaginatorResearchEquipmentClick(state.lazyParams);
    });

    return {
      t,
      onRowSelect,
      filters,
      state: computed(() => state),
      onPaginatorResearchEquipmentClick,
    };
  },
});
